import type { SubscriberListRef } from '../api/subscribersApi';

export type OwnerGroup = { key: string; label: string; role: string; lists: SubscriberListRef[]; subscribers: number; optedIn: number };

/** The research desk owns the shared topic lists. */
export const SHARED = 'Global Markets Research';

/** Lists by who owns them: the shared topic lists first, then each RM's client lists, RMs in name order. */
export function byOwner(lists: SubscriberListRef[]): OwnerGroup[] {
  const groups = new Map<string, OwnerGroup>();
  for (const l of lists) {
    const label = l.kind === 'topic' ? SHARED : (l.ownerName ?? 'Unassigned client lists');
    const group = groups.get(label) ?? { key: label, label, role: l.kind === 'topic' ? 'Topic lists' : 'RM', lists: [], subscribers: 0, optedIn: 0 };
    group.lists.push(l);
    group.subscribers += l.count;
    group.optedIn += l.optedInCount;
    groups.set(label, group);
  }
  return [...groups.values()].sort((a, b) => Number(b.label === SHARED) - Number(a.label === SHARED) || a.label.localeCompare(b.label));
}
